import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";
import { bookingFormCommon } from "../c005-bookingform-common";
import * as numeral from 'numeral';

export class memberPartnerRedeemGLVoucher {
	private partnerRdmForm:any   = $('#partner-redeem-voucher-form-lounge');
	private memberBase:any = new memberPortal();
	private bookingformcommon = new bookingFormCommon();
	$instance:any;
	private voucherList:any;
	private eligibilityFlag:any;
	private initialBal:any;
	private AwardCount:any;
	//private totalVocherRedeemed:any;
	

	/**
	 * initialize all form inputs with focus and filled effects
	 * find all instances of text inputs in all 3 forms on page
	 * combine them into an array and apply effect to all fields
	 * @return {any} [description]
	 */
	initTextInputs(): any {

     let defer = $.Deferred();
        let _self = this;
		//let channel = "LCP";
		let channel = $('[data-get-method]').attr('data-get-method');
		if(channel!=null && channel=="LCP"){
			var queryString = location.search.substring(1);
			var a = queryString.split("&");
			var value1 = a[0];
			var value2 = a[1];
			//alert("value1"+value1+"value2>>>"+value2);
       		$('#'+value2).removeClass("hidden");
			$('#'+value2).removeClass("inactive");
			$('#'+value2).addClass("active");
		}

		let cookieAccessToken = _self.getCookie("sapphire");
		var decodedToken = parseJwt(cookieAccessToken);
		let shoppingcartId  = $(".partner-redem-brands.active a").attr('id');
		//var max_voucher_count ='';
		var max_voucher_count = $(".partner-redem-brands.active input:hidden[class='max_voucher_count']").val();
		let redeemCampaignId  = $(".partner-redem-brands.active input:hidden[class='campaignId']").val();
		for(let a=1;a<=4;a++){
			$(".incrementer--partner-redeem--voucher-type"+a).attr("data-max",max_voucher_count);
		}
		
		//alert("max_coucher_count>>"+max_voucher_count);
		var data = {
			'loyaltyToken':	decodedToken.extension_loyaltyToken,
			'enrichId': decodedToken.extension_flyerid,
			'campaignID': redeemCampaignId,
			'shoppingcartId': shoppingcartId,
			'channel':channel
		};
		_self.bookingformcommon.preloader();
		$.ajax({
			type: 'POST',
			url: '/bin/services/new/redeemgoldvoucherusereligibility',
			data: data,
			success: function(data:any){
				//var json = JSON.parse(data);
				let json:any = null;
					if (typeof data === 'string') {
						json = JSON.parse(data);
					}	else {
						json = data;
					}
					_self.bookingformcommon.preloaderClose();
				_self.eligibilityFlag = json.eligibleFlag;
				_self.initialBal = json.currentBalance;
				//_self.totalVocherRedeemed = parseInt(json.totalVouchersRedeemed);
				_self.voucherList= json.voucherList;
				let redeemBal = _self.partnerRdmForm.find( '#partner-redeem--voucher-current-balance-gl');
				if (_self.eligibilityFlag == "true") {
					$(".voucherEligibity").removeClass("showclass");
					$(".voucherEligibity").addClass("hideclass");
					$(".overwhelming_resp").removeClass("showclass"); 
					$(".overwhelming_resp").addClass("hideclass");
					$(".maxcount_reached_onload").removeClass("showclass");
					$(".maxcount_reached_onload").addClass("hideclass");
					$(".maxcount_reached_onclick").removeClass("showclass"); 
					$(".maxcount_reached_onclick").addClass("hideclass");
					$(".partner-redeem-voucher").removeClass("hideclass");//DISPLAY
					$(".partner-redeem-voucher").addClass("showclass");//DISPLAY
					$(".partner-redemption").removeClass("hideclass");//DISPLAY
					$(".partner-redemption").addClass("showclass");//DISPLAY
					$(".partner-redem-incrementer").removeClass("hideclass");//DISPLAY
					$(".partner-redem-incrementer").addClass("showclass");//DISPLAY
					$(".successMsg").removeClass("showclass");
					$(".successMsg").addClass("hideclass");
					$(".errorMsg").removeClass("showclass");
					$(".errorMsg").addClass("hideclass");
					//$(".max4errorMsg").removeClass("showclass");
					//$(".max4errorMsg").addClass("hideclass");
					$(".rmMaxErrorMsg1").removeClass("showclass");
					$(".rmMaxErrorMsg1").addClass("hideclass");
					$(".rmMaxErrorMsg2").removeClass("showclass");
					$(".rmMaxErrorMsg2").addClass("hideclass");
					$(".rmMaxErrorMsg3").removeClass("showclass");
					$(".rmMaxErrorMsg3").addClass("hideclass");
					$(".rmMaxErrorMsg4").removeClass("showclass");
					$(".rmMaxErrorMsg4").addClass("hideclass");
					$(".btn-member--submit").addClass("disablee");
					$(".date_expire").removeClass("showclass");
					$(".date_expire").addClass("hideclass");
					if(parseInt(_self.initialBal)<=0)
					{
						$(".overwhelming_resp").removeClass("showclass"); 
						$(".overwhelming_resp").addClass("hideclass");
						$(".maxcount_reached_onload").removeClass("showclass");
						$(".maxcount_reached_onload").addClass("hideclass");
						$(".maxcount_reached_onclick").removeClass("showclass"); 
						$(".maxcount_reached_onclick").addClass("hideclass"); 
						//$('.voucherEligibity').text("Sorry, you have insufficient MILES points for the redemption.");
						$(".voucherEligibity").removeClass("hideclass"); //DISPLAY
						$(".voucherEligibity").addClass("showclass"); //DISPLAY
						$(".partner-redeem-voucher").removeClass("hideclass"); //DISPLAY
						$(".partner-redeem-voucher").addClass("showclass"); //DISPLAY
						$(".partner-redemption").removeClass("hideclass");
						$(".partner-redemption").addClass("showclass");
						$(".partner-redem-incrementer").removeClass("hideclass");
						$(".partner-redem-incrementer").addClass("showclass");
					}
					
					for(let i=1;i<=_self.voucherList.length;i++)
					{
						document.getElementById("label--partner-redeem--voucher-type"+i).innerHTML = json.voucherList[i-1].RedeemVoucher;
						//document.getElementById("awardcode_input"+i).setAttribute("value",json.voucherList[i-1].AwardCode);
						//_self.partnerRdmForm.find( '#awardcode_input'+i).val(json.voucherList[i-1].AwardCode);
						$("#displayClass"+i).removeClass("hideclass");
						$("#displayClass"+i).addClass("showclass");
					}
					redeemBal.val(json.currentBalance);
					//_self.setRedeemVoucherDtls(json);
					_self.getVoucherTypeValues(_self.initialBal,_self.voucherList,max_voucher_count);
				}
				else if(_self.eligibilityFlag == "false")
				{
					redeemBal.val(json.currentBalance);
					$(".maxcount_reached_onload").removeClass("showclass");
					$(".maxcount_reached_onload").addClass("hideclass");
					$(".maxcount_reached_onclick").removeClass("showclass"); 
					$(".maxcount_reached_onclick").addClass("hideclass");
					$(".overwhelming_resp").removeClass("hideclass"); //DISPLAY
					$(".overwhelming_resp").addClass("showclass"); //DISPLAY
					//$('.voucherEligibity').text("Thank you for your support. Due to overwhelming response, all vouchers have been fully redeemed. Keep a lookout for our next campaign.");
					$(".voucherEligibity").removeClass("showclass");
					$(".voucherEligibity").addClass("hideclass");
					$(".partner-redeem-voucher").removeClass("hideclass"); //DISPLAY
					$(".partner-redeem-voucher").addClass("showclass"); //DISPLAY
					$(".partner-redemption").removeClass("hideclass");
					$(".partner-redemption").addClass("showclass");
					$(".partner-redem-incrementer").removeClass("hideclass");
					$(".partner-redem-incrementer").addClass("showclass");
					$(".successMsg").removeClass("showclass");
					$(".successMsg").addClass("hideclass");
					$(".errorMsg").removeClass("showclass");
					$(".errorMsg").addClass("hideclass");
					//$(".max4errorMsg").removeClass("showclass");
					//$(".max4errorMsg").addClass("hideclass");
					$(".rmMaxErrorMsg1").removeClass("showclass");
					$(".rmMaxErrorMsg1").addClass("hideclass");
					$(".rmMaxErrorMsg2").removeClass("showclass");
					$(".rmMaxErrorMsg2").addClass("hideclass");
					$(".rmMaxErrorMsg3").removeClass("showclass");
					$(".rmMaxErrorMsg3").addClass("hideclass");
					$(".rmMaxErrorMsg4").removeClass("showclass");
					$(".rmMaxErrorMsg4").addClass("hideclass");
					$(".btn-member--submit").addClass("disablee");
					$(".date_expire").removeClass("showclass");
					$(".date_expire").addClass("hideclass");
					for(let i=1;i<=_self.voucherList.length;i++)
					{
						document.getElementById("label--partner-redeem--voucher-type"+i).innerHTML = json.voucherList[i-1].RedeemVoucher;
						//document.getElementById("awardcode_input"+i).setAttribute("value",json.voucherList[i-1].AwardCode);
						//_self.partnerRdmForm.find( '#awardcode_input'+i).val(json.voucherList[i-1].AwardCode);
						$("#displayClass"+i).removeClass("hideclass");
						$("#displayClass"+i).addClass("showclass");
					}
					for(let a=1;a<=4;a++)
						{
							if(!$("#partner-redeem--voucher-type"+a+"--increment").hasClass("disablee"))
							{
								$("#partner-redeem--voucher-type"+a+"--increment").addClass("disablee");
							}
						}
				}else if(_self.eligibilityFlag == "DateError"){

					$(".maxcount_reached_onload").removeClass("showclass");
					$(".maxcount_reached_onload").addClass("hideclass");
					$(".maxcount_reached_onclick").removeClass("showclass"); 
					$(".maxcount_reached_onclick").addClass("hideclass");
					$(".overwhelming_resp").removeClass("showclass"); 
					$(".overwhelming_resp").addClass("hideclass"); 
					//$('.voucherEligibity').text("Thank you for your support. Due to overwhelming response, all vouchers have been fully redeemed. Keep a lookout for our next campaign.");
					$(".voucherEligibity").removeClass("showclass");
					$(".voucherEligibity").addClass("hideclass");
					$(".partner-redeem-voucher").removeClass("hideclass"); //DISPLAY
					$(".partner-redeem-voucher").addClass("showclass"); //DISPLAY
					$(".partner-redemption").removeClass("hideclass");//DISPLAY
					$(".partner-redemption").addClass("showclass"); //DISPLAY
					$(".partner-redem-incrementer").removeClass("hideclass"); //DISPLAY
					$(".partner-redem-incrementer").addClass("showclass"); //DISPLAY
					$(".successMsg").removeClass("showclass");
					$(".successMsg").addClass("hideclass");
					$(".errorMsg").removeClass("showclass");
					$(".errorMsg").addClass("hideclass");
					$(".date_expire").removeClass("hideclass");//DISPLAY
					$(".date_expire").addClass("showclass");//DISPLAY
					$(".rmMaxErrorMsg1").removeClass("showclass");
					$(".rmMaxErrorMsg1").addClass("hideclass");
					$(".rmMaxErrorMsg2").removeClass("showclass");
					$(".rmMaxErrorMsg2").addClass("hideclass");
					$(".rmMaxErrorMsg3").removeClass("showclass");
					$(".rmMaxErrorMsg3").addClass("hideclass");
					$(".rmMaxErrorMsg4").removeClass("showclass");
					$(".rmMaxErrorMsg4").addClass("hideclass");
					$(".btn-member--submit").addClass("disablee");
					for(let i=1;i<=_self.voucherList.length;i++)
					{
						document.getElementById("label--partner-redeem--voucher-type"+i).innerHTML = json.voucherList[i-1].RedeemVoucher;
						//document.getElementById("awardcode_input"+i).setAttribute("value",json.voucherList[i-1].AwardCode);
						//_self.partnerRdmForm.find( '#awardcode_input'+i).val(json.voucherList[i-1].AwardCode);
						$("#displayClass"+i).removeClass("hideclass");
						$("#displayClass"+i).addClass("showclass");
					}
					for(let a=1;a<=4;a++)
						{
							if(!$("#partner-redeem--voucher-type"+a+"--increment").hasClass("disablee"))
							{
								$("#partner-redeem--voucher-type"+a+"--increment").addClass("disablee");
							}
						}

				}else{

					$(".maxcount_reached_onload").removeClass("showclass");
					$(".maxcount_reached_onload").addClass("hideclass");
					$(".maxcount_reached_onclick").removeClass("showclass"); 
					$(".maxcount_reached_onclick").addClass("hideclass");
					$(".overwhelming_resp").removeClass("showclass"); //DISPLAY
					$(".overwhelming_resp").addClass("hideclass"); //DISPLAY
					//$('.voucherEligibity').text("Thank you for your support. Due to overwhelming response, all vouchers have been fully redeemed. Keep a lookout for our next campaign.");
					$(".voucherEligibity").removeClass("showclass");
					$(".voucherEligibity").addClass("hideclass");
					$(".partner-redeem-voucher").removeClass("showclass"); //DISPLAY
					$(".partner-redeem-voucher").addClass("hideclass"); //DISPLAY
					$(".partner-redemption").removeClass("showclass");
					$(".partner-redemption").addClass("hideclass");
					$(".partner-redem-incrementer").removeClass("showclass");
					$(".partner-redem-incrementer").addClass("hideclass");
					$(".successMsg").removeClass("showclass");
					$(".successMsg").addClass("hideclass");
					$(".onload_errorMsg").removeClass("hideclass");//DISPLAY
					$(".onload_errorMsg").addClass("showclass");//DISPLAY
					$(".date_expire").removeClass("showclass");//DISPLAY
					$(".date_expire").addClass("hideclass");//DISPLAY
					//$(".max4errorMsg").removeClass("showclass");
					//$(".max4errorMsg").addClass("hideclass");
					$(".rmMaxErrorMsg1").removeClass("showclass");
					$(".rmMaxErrorMsg1").addClass("hideclass");
					$(".rmMaxErrorMsg2").removeClass("showclass");
					$(".rmMaxErrorMsg2").addClass("hideclass");
					$(".rmMaxErrorMsg3").removeClass("showclass");
					$(".rmMaxErrorMsg3").addClass("hideclass");
					$(".rmMaxErrorMsg4").removeClass("showclass");
					$(".rmMaxErrorMsg4").addClass("hideclass");
					$(".btn-member--submit").addClass("disablee");

				}
				defer.resolve(json);			
			}, error: function(error: any) {
				
				_self.bookingformcommon.preloaderClose();
				defer.reject(error);
			}
		});
		return defer.promise();
	
	function parseJwt (token:any): any {
		var base64Url = token.split('.')[1];
		var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));
	
		return JSON.parse(base64);
	};
}

getCookie(name:string): any {
	var value = "; " + document.cookie;
	var parts = value.split("; " + name + "=");
	var cookieVal:any;
	if (parts.length == 2) {
		cookieVal = parts.pop().split(";").shift();
		return cookieVal;
	}
}
	initSelectizeInputs(): any {
		let _self = this;
		let totalInput      = _self.partnerRdmForm.find('#partner-redeem--voucher-total');
		let incremeterInput = _self.partnerRdmForm.find('.partner-redeem--voucher-to-use');
		let defer = $.Deferred();
		
		// when incrementer value changes
		incremeterInput.on('incrementer.changed', function(e:any, val:any){
			let selectedVoucher=e.target.id;
			console.log(e);
			let rm50TotMiles = 0;
			let rm100TotMiles = 0;
			let rm150TotMiles = 0;
			let rm200TotMiles = 0;
			let totMilesValue = 0;
			let currentBalVal = 0;
			let voucherUnit = 0;
			let voucherUnit1 = 0;
			let voucherUnit2 = 0;
			let voucherUnit3 = 0;
			let voucherUnit4 = 0;
			let rm50Voucher=0;
			let rm100Voucher=0;
			let rm150Voucher=0;
			let rm200Voucher=0;
			//let rmCount1=0;
			//let rmCount2=0;
			//let rmCount3=0;
			//let rmCount4=0;
			let voucherUnitCount = 0;
			//let firstIndex = 0;
			let totVocherRedemed=0;
			let redeemBalance       = _self.partnerRdmForm.find('#partner-redeem--voucher-current-balance-gl');
			let shoppingCartActive  = $(".partner-redem-brands.active a").attr('id');
            //let max_voucher_count = $("#max_voucher_count").val();
            var max_voucher_count_on_inc = $(".partner-redem-brands.active input:hidden[class='max_voucher_count']").val();
        
						var eligibilityFlag = _self.eligibilityFlag;
						let firstIndex = parseInt(_self.initialBal);
						//totVocherRedemed = parseInt(_self.totalVocherRedeemed);
						let voucherListIncr= _self.voucherList;
						let redeemBal = _self.partnerRdmForm.find( '#partner-redeem--voucher-current-balance-gl');
						if (eligibilityFlag == "true") {
							//getIncreamentVoucherDtls(json);
							for(let i=1;i<=voucherListIncr.length;i++)
							{
								let countVoucher=_self.partnerRdmForm.find('#partner-redeem--voucher-type'+i+'input').val();
								let countVal=0;
								if(countVoucher!=""){
									countVal=parseInt(countVoucher);
									if(i==1){
										voucherUnit1=countVal;
										rm50Voucher=parseInt(voucherListIncr[i-1].AwardValue);
										//rmCount1=_self.AwardCount;
									}else if(i==2){
										voucherUnit2=countVal;
										rm100Voucher=parseInt(voucherListIncr[i-1].AwardValue);
										//rmCount2=_self.AwardCount;
									}else if(i==3){
										voucherUnit3=countVal;
										rm150Voucher=parseInt(voucherListIncr[i-1].AwardValue);
										//rmCount3=_self.AwardCount;
									}else if(i==4){
										voucherUnit4=countVal;
										rm200Voucher=parseInt(voucherListIncr[i-1].AwardValue);
										//rmCount4=_self.AwardCount;
									}
								}
								voucherUnitCount=voucherUnitCount+countVal;
							}
							if(totVocherRedemed>0)
							{
								voucherUnitCount=totVocherRedemed+voucherUnitCount;
							}else
							{
								voucherUnitCount=voucherUnitCount-totVocherRedemed;
							}
							//voucherUnit = parseInt(val);
							if(voucherUnitCount){
								if(voucherUnit1){
									if(rm50Voucher>0){
										rm50TotMiles = voucherUnit1 * rm50Voucher;
									}
								}
								if(voucherUnit2){
									if(rm100Voucher>0){
										rm100TotMiles = voucherUnit2 * rm100Voucher;
									}
								}
								if(voucherUnit3){
									if(rm150Voucher>0){
										rm150TotMiles = voucherUnit3 * rm150Voucher;
									}
								}
								if(voucherUnit4){
									if(rm200Voucher>0){
										rm200TotMiles = voucherUnit4 * rm200Voucher;
									}
								}
								totMilesValue=rm50TotMiles+rm100TotMiles+rm150TotMiles+rm200TotMiles;
								console.log(voucherUnit1, totMilesValue);
								totalInput.val(totMilesValue);
								let redemBalValues  = parseInt(redeemBalance.val());
								let totVal          = parseInt(totalInput.val());
								currentBalVal=redemBalValues-totVal;
								_self.getVoucherTypeValues(currentBalVal,voucherListIncr,voucherUnitCount);
								if(totVal>0)
								{
									$(".btn-member--submit").removeClass("disablee");
								}else{
									$(".btn-member--submit").addClass("disablee");
								}
								/*if(voucherUnitCount==4){
									for(let j=1;j<=voucherListIncr.length;j++){
										if($("#partner-redeem--voucher-type"+j+"--increment").hasClass("disablee")){
										}else{
											$("#partner-redeem--voucher-type"+j+"--increment").addClass("disablee");
										}
									}
								}*/
							}
						}else{
							for(let k=1;k<=voucherListIncr.length;k++){
								if($("#partner-redeem--voucher-type"+k+"--increment").hasClass("disablee")){
								}else{
									$("#partner-redeem--voucher-type"+k+"--increment").addClass("disablee");
								}
							}					
						}

		});
	}
	/**
	 * [initIncrementer description]
	 * @return {any} [description]
	 */
	initIncrementer(): any {
		

		
		// $('#partner-redeem--voucher-type1').on("change",function(){
		// 	let textValue : number = $(this).val() * 1000;
		// 	$('#partner-redeem--voucher-total').text(textValue);
		// 	});

		let _self = this;
		let inputElArr:any = $.makeArray(_self.partnerRdmForm.find('.incrementer'));
		_self.setIntialIncreamentVal(inputElArr,"N");
		//_self.memberBase.initIncrementer(inputElArr);
	}
	/**
	 * [initShopCart description]
	 * @return {any} [description]
	 */
	initShopCart(): any {
		let defer = $.Deferred();
		let _self = this;
		$(".partner-redem-brands a").click(function() {
			
			let cartId=this.id;
			$('.partner-redem-brands').removeClass("active");
			$('.partner-redem-brands').addClass("inactive");
			$(this).parent().removeClass("inactive");
			$(this).parent().addClass("active");

			$('.below_shopping_cart_description').removeClass("showclass");
			$('.below_shopping_cart_description').addClass("hideclass");
			$('.bottom_TNC_display').removeClass("showclass");
			$('.bottom_TNC_display').addClass("hideclass");
			let cartId_disp_desc=cartId+"_desc";
			let cartId_disp_tnc=cartId+"_tnc";
			$('#'+cartId_disp_desc).removeClass("hideclass");
			$('#'+cartId_disp_desc).addClass("showclass");
			$('#'+cartId_disp_tnc).removeClass("hideclass");
			$('#'+cartId_disp_tnc).addClass("showclass");



			for(let i=1;i<=4;i++)
			{
				$("#displayClass"+i).removeClass("showclass");
				$("#displayClass"+i).addClass("hideclass");
			}
			let redeemBal = _self.partnerRdmForm.find( '#partner-redeem--voucher-current-balance-gl');
			let totalInput= _self.partnerRdmForm.find('#partner-redeem--voucher-total');
            var max_voucher_count_shop_cart = $(".partner-redem-brands.active input:hidden[class='max_voucher_count']").val();
			
			let redeemCampaignId  = $(".partner-redem-brands.active input:hidden[class='campaignId']").val();
			let inputElArr:any = $.makeArray(_self.partnerRdmForm.find('.incrementer'));
			_self.setIntialIncreamentVal(inputElArr,"Y");
				let cookieAccessToken = _self.getCookie("sapphire");
				var decodedToken = parseJwt(cookieAccessToken);
				//let channel = "LCP";
				let channel = $('[data-get-method]').attr('data-get-method');
				var data = {
					'loyaltyToken':	decodedToken.extension_loyaltyToken,
					'enrichId': decodedToken.extension_flyerid,
					'campaignID':redeemCampaignId,
					'shoppingcartId':cartId,
					'channel':channel
				};
				$.ajax({
					type: 'POST',
					url: '/bin/services/new/redeemgoldvoucherusereligibility',
					data: data,
					success: function(data:any){
						//var json = JSON.parse(data);
						let json:any = null;
						if (typeof data === 'string') {
							json = JSON.parse(data);
						}	else {
							json = data;
						}
						_self.eligibilityFlag = json.eligibleFlag;
						_self.initialBal = json.currentBalance;
						//_self.totalVocherRedeemed = parseInt(json.totalVouchersRedeemed);
						_self.voucherList= json.voucherList;
						//let redeemBal = _self.partnerRdmForm.find( '#partner-redeem--voucher-current-balance');
						if (_self.eligibilityFlag == "true") {
							$(".voucherEligibity").removeClass("showclass");
							$(".voucherEligibity").addClass("hideclass");
							$(".overwhelming_resp").removeClass("showclass"); 
							$(".overwhelming_resp").addClass("hideclass");
							$(".maxcount_reached_onload").removeClass("showclass");
							$(".maxcount_reached_onload").addClass("hideclass");
							$(".maxcount_reached_onclick").removeClass("showclass"); 
							$(".maxcount_reached_onclick").addClass("hideclass");
							$(".partner-redeem-voucher").removeClass("hideclass"); //DISPLAY
							$(".partner-redeem-voucher").addClass("showclass"); //DISPLAY
							$(".partner-redemption").removeClass("hideclass");//DISPLAY
							$(".partner-redemption").addClass("showclass");//DISPLAY
							$(".partner-redem-incrementer").removeClass("hideclass");//DISPLAY
							$(".partner-redem-incrementer").addClass("showclass");//DISPLAY
							$(".successMsg").removeClass("showclass"); 
							$(".successMsg").addClass("hideclass");
							$(".errorMsg").removeClass("showclass");
							$(".errorMsg").addClass("hideclass");
							$(".onload_errorMsg").removeClass("showclass");//DISPLAY
					        $(".onload_errorMsg").addClass("hideclass");//DISPLAY
							//$(".max4errorMsg").removeClass("showclass");
							//$(".max4errorMsg").addClass("hideclass");
							$(".rmMaxErrorMsg1").removeClass("showclass");
							$(".rmMaxErrorMsg1").addClass("hideclass");
							$(".rmMaxErrorMsg2").removeClass("showclass");
							$(".rmMaxErrorMsg2").addClass("hideclass");
							$(".rmMaxErrorMsg3").removeClass("showclass");
							$(".rmMaxErrorMsg3").addClass("hideclass");
							$(".rmMaxErrorMsg4").removeClass("showclass");
							$(".rmMaxErrorMsg4").addClass("hideclass");
							$(".btn-member--submit").addClass("disablee");
							$(".date_expire").removeClass("showclass");
							$(".date_expire").addClass("hideclass");
							if(parseInt(_self.initialBal)<=0)
							{
								$(".overwhelming_resp").removeClass("showclass"); 
								$(".overwhelming_resp").addClass("hideclass");
								$(".maxcount_reached_onload").removeClass("showclass");
								$(".maxcount_reached_onload").addClass("hideclass");
								$(".maxcount_reached_onclick").removeClass("showclass"); 
								$(".maxcount_reached_onclick").addClass("hideclass");
								//$('.voucherEligibity').text("Sorry, you have insufficient MILES points for the redemption.");
								$(".voucherEligibity").removeClass("hideclass"); //DISPLAY
								$(".voucherEligibity").addClass("showclass"); //DISPLAY
								$(".partner-redeem-voucher").removeClass("hideclass"); //DISPLAY
								$(".partner-redeem-voucher").addClass("showclass"); //DISPLAY
								$(".partner-redemption").removeClass("showclass");
								$(".partner-redemption").addClass("hideclass");
								$(".partner-redem-incrementer").removeClass("hideclass");
								$(".partner-redem-incrementer").addClass("showclass");
							}
							for(let i=1;i<=_self.voucherList.length;i++)
							{
								document.getElementById("label--partner-redeem--voucher-type"+i).innerHTML = json.voucherList[i-1].RedeemVoucher;

								//document.getElementById("awardcode_input"+i).setAttribute("value",json.voucherList[i-1].AwardCode);
								//_self.partnerRdmForm.find( '#awardcode_input'+i).val(json.voucherList[i-1].AwardCode);
								$("#displayClass"+i).removeClass("hideclass");
								$("#displayClass"+i).addClass("showclass");
							}
							redeemBal.val(json.currentBalance);
							totalInput.val(0);
							//_self.setRedeemVoucherDtls(json);
							_self.getVoucherTypeValues(_self.initialBal,_self.voucherList,max_voucher_count_shop_cart);
						}
						else if(_self.eligibilityFlag == "false")
						{
							redeemBal.val(json.currentBalance);
							$(".overwhelming_resp").removeClass("hideclass"); //DISPLAY
							$(".overwhelming_resp").addClass("showclass"); //DISPLAY
							$(".maxcount_reached_onload").removeClass("showclass");
							$(".maxcount_reached_onload").addClass("hideclass");
							$(".maxcount_reached_onclick").removeClass("showclass"); 
							$(".maxcount_reached_onclick").addClass("hideclass");
							//$('.voucherEligibity').text("Thank you for your support. Due to overwhelming response, all vouchers have been fully redeemed. Keep a lookout for our next campaign.");
							$(".voucherEligibity").removeClass("showclass"); 
							$(".voucherEligibity").addClass("hideclass"); 
							$(".partner-redeem-voucher").removeClass("hideclass");  //DISPLAY
							$(".partner-redeem-voucher").addClass("showclass"); //DISPLAY
							$(".partner-redemption").removeClass("hideclass");//DISPLAY
							$(".partner-redemption").addClass("showclass");//DISPLAY
							$(".partner-redem-incrementer").removeClass("hideclass");//DISPLAY
							$(".partner-redem-incrementer").addClass("showclass");//DISPLAY
							$(".successMsg").removeClass("showclass");
							$(".successMsg").addClass("hideclass");
							$(".errorMsg").removeClass("showclass");
							$(".errorMsg").addClass("hideclass");
							$(".onload_errorMsg").removeClass("showclass");
					        $(".onload_errorMsg").addClass("hideclass");
							$(".btn-member--submit").addClass("disablee");
							$(".date_expire").removeClass("showclass");
							$(".date_expire").addClass("hideclass");
							for(let i=1;i<=_self.voucherList.length;i++)
							{
								document.getElementById("label--partner-redeem--voucher-type"+i).innerHTML = json.voucherList[i-1].RedeemVoucher;
								//document.getElementById("awardcode_input"+i).setAttribute("value",json.voucherList[i-1].AwardCode);
								//_self.partnerRdmForm.find( '#awardcode_input'+i).val(json.voucherList[i-1].AwardCode);
								$("#displayClass"+i).removeClass("hideclass");
								$("#displayClass"+i).addClass("showclass");
							}
							for(let a=1;a<=4;a++)
								{
									if(!$("#partner-redeem--voucher-type"+a+"--increment").hasClass("disablee"))
									{
										$("#partner-redeem--voucher-type"+a+"--increment").addClass("disablee");
									}
								}
						}else if(_self.eligibilityFlag == "DateError"){

							$(".maxcount_reached_onload").removeClass("showclass");
							$(".maxcount_reached_onload").addClass("hideclass");
							$(".maxcount_reached_onclick").removeClass("showclass"); 
							$(".maxcount_reached_onclick").addClass("hideclass");
							$(".overwhelming_resp").removeClass("showclass"); 
							$(".overwhelming_resp").addClass("hideclass"); 
							//$('.voucherEligibity').text("Thank you for your support. Due to overwhelming response, all vouchers have been fully redeemed. Keep a lookout for our next campaign.");
							$(".voucherEligibity").removeClass("showclass");
							$(".voucherEligibity").addClass("hideclass");
							$(".partner-redeem-voucher").removeClass("hideclass"); //DISPLAY
							$(".partner-redeem-voucher").addClass("showclass"); //DISPLAY
							$(".partner-redemption").removeClass("hideclass"); //DISPLAY
							$(".partner-redemption").addClass("showclass"); //DISPLAY
							$(".partner-redem-incrementer").removeClass("hideclass"); //DISPLAY
							$(".partner-redem-incrementer").addClass("showclass"); //DISPLAY
							$(".successMsg").removeClass("showclass");
							$(".successMsg").addClass("hideclass");
							$(".errorMsg").removeClass("showclass");
							$(".errorMsg").addClass("hideclass");
							$(".onload_errorMsg").removeClass("showclass");
					        $(".onload_errorMsg").addClass("hideclass");
							$(".date_expire").removeClass("hideclass");//DISPLAY
							$(".date_expire").addClass("showclass");//DISPLAY
							$(".rmMaxErrorMsg1").removeClass("showclass");
							$(".rmMaxErrorMsg1").addClass("hideclass");
							$(".rmMaxErrorMsg2").removeClass("showclass");
							$(".rmMaxErrorMsg2").addClass("hideclass");
							$(".rmMaxErrorMsg3").removeClass("showclass");
							$(".rmMaxErrorMsg3").addClass("hideclass");
							$(".rmMaxErrorMsg4").removeClass("showclass");
							$(".rmMaxErrorMsg4").addClass("hideclass");
							$(".btn-member--submit").addClass("disablee");
							for(let i=1;i<=_self.voucherList.length;i++)
							{
								document.getElementById("label--partner-redeem--voucher-type"+i).innerHTML = json.voucherList[i-1].RedeemVoucher;
								//document.getElementById("awardcode_input"+i).setAttribute("value",json.voucherList[i-1].AwardCode);
								//_self.partnerRdmForm.find( '#awardcode_input'+i).val(json.voucherList[i-1].AwardCode);
								$("#displayClass"+i).removeClass("hideclass");
								$("#displayClass"+i).addClass("showclass");
							}
							for(let a=1;a<=4;a++)
								{
									if(!$("#partner-redeem--voucher-type"+a+"--increment").hasClass("disablee"))
									{
										$("#partner-redeem--voucher-type"+a+"--increment").addClass("disablee");
									}
								}
		
						}else{

							$(".maxcount_reached_onload").removeClass("showclass");
					$(".maxcount_reached_onload").addClass("hideclass");
					$(".maxcount_reached_onclick").removeClass("showclass"); 
					$(".maxcount_reached_onclick").addClass("hideclass");
					$(".overwhelming_resp").removeClass("showclass"); 
					$(".overwhelming_resp").addClass("hideclass"); 
					//$('.voucherEligibity').text("Thank you for your support. Due to overwhelming response, all vouchers have been fully redeemed. Keep a lookout for our next campaign.");
					$(".voucherEligibity").removeClass("showclass");
					$(".voucherEligibity").addClass("hideclass");
					$(".partner-redeem-voucher").removeClass("showclass"); 
					$(".partner-redeem-voucher").addClass("hideclass"); 
					$(".partner-redemption").removeClass("showclass");
					$(".partner-redemption").addClass("hideclass");
					$(".partner-redem-incrementer").removeClass("showclass");
					$(".partner-redem-incrementer").addClass("hideclass");
					$(".successMsg").removeClass("showclass");
					$(".successMsg").addClass("hideclass");
					$(".onload_errorMsg").removeClass("hideclass");//DISPLAY
					$(".onload_errorMsg").addClass("showclass");//DISPLAY
					$(".errorMsg").removeClass("showclass");
					$(".errorMsg").addClass("hideclass");
					//$(".max4errorMsg").removeClass("showclass");
					//$(".max4errorMsg").addClass("hideclass");
					$(".rmMaxErrorMsg1").removeClass("showclass");
					$(".rmMaxErrorMsg1").addClass("hideclass");
					$(".rmMaxErrorMsg2").removeClass("showclass");
					$(".rmMaxErrorMsg2").addClass("hideclass");
					$(".rmMaxErrorMsg3").removeClass("showclass");
					$(".rmMaxErrorMsg3").addClass("hideclass");
					$(".rmMaxErrorMsg4").removeClass("showclass");
					$(".rmMaxErrorMsg4").addClass("hideclass");
					$(".btn-member--submit").addClass("disablee");
					$(".date_expire").removeClass("showclass");
					$(".date_expire").addClass("hideclass");

				}
						defer.resolve(json);			
					}, error: function(error: any) {
						defer.reject(error);
					}
				});
				return defer.promise();
			
			function parseJwt (token:any): any {
				var base64Url = token.split('.')[1];
				var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
					return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
				}).join(''));
			
				return JSON.parse(base64);
			};
		});
	}
	getVoucherTypeValues(curVal:any,voucherList:any,max_voucher_count:any):any{
	
		let _self = this;
		let rmcode1:any;
		let rmcodeValue1=0;
		let rmcode2:any;
		let rmcodeValue2=0;
		let rmcode3:any;
		let rmcodeValue3=0;
		let rmcode4:any;
		let rmcodeValue4=0;
		let rmcodeCount1=0;
		let rmcodeCount2=0;
		let rmcodeCount3=0;
		let rmcodeCount4=0;
		let rmVoucherUnit1=0;
		let rmVoucherUnit2=0;
		let rmVoucherUnit3=0;
		let rmVoucherUnit4=0;
		let totalCountVouchers=0;
		let onLoadVoucherCount=0;
		if(voucherList!=null && voucherList.length>0){
			for(let a=1;a<=voucherList.length;a++){
				let countVoucher=_self.partnerRdmForm.find('#partner-redeem--voucher-type'+a+'input').val();
				if(countVoucher!=""){
					onLoadVoucherCount=parseInt(countVoucher);
					totalCountVouchers=totalCountVouchers+onLoadVoucherCount;
				}
			}
			for(let i=1;i<=voucherList.length;i++){
				//window['rmcode'+i] = data.eligibilityBean.voucherList[i].AwardCode;
				//window['rmcodeValue'+i] = data.eligibilityBean.voucherList[i].AwardValue;
				let voucherCount=$("#partner-redeem--voucher-type"+i+"input").val();
				
				let valCount=0;
				if(i==1){
					rmcode1 = voucherList[i-1].RedeemVoucher;
					rmcodeValue1 = parseInt(voucherList[i-1].AwardValue);
					//rmcodeCount1 = _self.AwardCount;
					if(voucherCount!=""){
						valCount=parseInt(voucherCount);
						rmVoucherUnit1=valCount;
					}
				}
				if(i==2)
				{
					rmcode2 =voucherList[i-1].RedeemVoucher;
					rmcodeValue2 = parseInt(voucherList[i-1].AwardValue);
					//rmcodeCount2 = _self.AwardCount;
					if(voucherCount!=""){
						valCount=parseInt(voucherCount);
						rmVoucherUnit2=valCount;
					}
				}
				if(i==3)
				{
					rmcode3 = voucherList[i-1].RedeemVoucher;
					rmcodeValue3 = parseInt(voucherList[i-1].AwardValue);
					//rmcodeCount3 = _self.AwardCount;
					if(voucherCount!=""){
						valCount=parseInt(voucherCount);
						rmVoucherUnit3=valCount;
					}
				}
				if(i==4)
				{
					rmcode4 = voucherList[i-1].RedeemVoucher;
					rmcodeValue4 = parseInt(voucherList[i-1].AwardValue);
					//rmcodeCount4 = _self.AwardCount;
					if(voucherCount!=""){
						valCount=parseInt(voucherCount);
						rmVoucherUnit4=valCount;
					}
				}
			}
		    		
		}else{
			$(".partner-redeem-voucher").removeClass("hideclass"); //DISPLAY
			$(".partner-redeem-voucher").addClass("showclass"); //DISPLAY
			$(".maxcount_reached_onclick").removeClass("showclass");
			$(".maxcount_reached_onclick").addClass("hideclass");
			$(".maxcount_reached_onload").removeClass("showclass");
			$(".maxcount_reached_onload").addClass("hideclass");
			$(".overwhelming_resp").removeClass("showclass"); 
			$(".overwhelming_resp").addClass("hideclass");
			//$('.voucherEligibity').text("Sorry, you have insufficient MILES points for the redemption.");
			$(".voucherEligibity").removeClass("hideclass"); //DISPLAY
			$(".voucherEligibity").addClass("showclass"); //DISPLAY
			$(".partner-redeem--voucher-to-use").removeClass("showclass");
			$(".partner-redeem--voucher-to-use").addClass("hideclass");
			$(".partner-redemption").removeClass("showclass");
			$(".partner-redemption").addClass("hideclass");
			$(".partner-redem-incrementer").removeClass("showclass");
			$(".partner-redem-incrementer").addClass("hideclass");
		}	
	}
	setIntialIncreamentVal(inputElArr:any,cartId:any): any{
		for (var i=0, len=inputElArr.length; i<len; i++) {
			let el = $(inputElArr[i]);
			let btnMinus       = el.find('.incrementer__btn.incrementer--decrement');
			let btnPlus        = el.find('.incrementer__btn.incrementer--increment');
			let elDisplay      = el.find('.incrementer__display');
			let input          = el.find('input[type="hidden"]');
			let curVal:number = 0;
			let	params = {
				'min': parseInt(el[0].dataset.min),
				'max': parseInt(el[0].dataset.max),
				'initvalue': parseInt(el[0].dataset.initValue)
			};
			// btnMinus click handler
			// - on click, increment display value & input[hidden] value
			btnMinus.on('click', function(e:any) {
				e.preventDefault();
				e.stopPropagation();
				cartId="N";
				if ("vibrate" in navigator) {
					// vibration API supported
					navigator.vibrate(25);
				}
				curVal = setIncrementer(elDisplay, input, curVal, params, 'decrement');
				//alert("on decrement>>"+curVal);
			});

			// btnMinus click hold handler
			// - on hold down click,
			//   automatically decrement by 1 unit per 100ms
			//   until mouseout
			//let btnMinInterval:any;

			// btnMinus.on('mousedown', function(e:any) {
			// 	e.preventDefault();
			// 	e.stopPropagation();
			// 	cartId="N";
			// 	btnMinInterval = setInterval(function() {
			// 		curVal = setIncrementer(elDisplay, input, curVal, params, 'decrement');
			// 	}, 200);
			// }).on('mouseup mouseleave', function() {
			// 	clearInterval(btnMinInterval);
			// });

			// btnPlus click handler
			// - on click, increment display value & input[hidden] value
			btnPlus.on('click', function(e:any) {
				e.preventDefault();
				e.stopPropagation();
				cartId="N";
				if ("vibrate" in navigator) {
					// vibration API supported
					navigator.vibrate(35);
				}
				curVal = setIncrementer(elDisplay, input, curVal, params, 'increment');
				//alert("on increment>>"+curVal);
			});

			// btnPlus click hold handler
			// - on hold down click,
			//   automatically decrement by 1 unit per 100ms
			//   until mouseout
			//let btnPlusInterval:any;
			// btnPlus.on('mousedown', function(e:any) {
			// 	e.preventDefault();
			// 	e.stopPropagation();
			// 	cartId="N";
			// 	// set initial delay (500ms)
			// 	btnPlusInterval = setInterval(function() {
			// 		curVal = setIncrementer(elDisplay, input, curVal, params, 'increment');
			// 	}, 200);
			// }).on('mouseup mouseleave', function() {
			// 	clearInterval(btnPlusInterval);
			// });
			if(cartId=="Y")
			{
				if(i<len){
					curVal = setIncrementer(elDisplay, input, 0, params, 'inc');
				}else{
					cartId="N";
				}
				
			}
		}

		/**
		 * common function to set incrementer value/display for click/hold events
		 * @param  {any}    elDisplay [description]
		 * @param  {any}    input     [description]
		 * @param  {any}    curVal    [description]
		 * @param  {any}    params    [description]
		 * @param  {string} type      [description]
		 * @return {any}              [description]
		 */
		function setIncrementer(elDisplay:any, input:any, curVal:any, params:any, type:string,):any {
			if (type == 'decrement') {				
				if (curVal > params.min) {
					curVal--;
					if(curVal == 0){
						$(".btn-member--submit").addClass("disablee");
						$('#partner-redeem--voucher-total').val(0);
					}
				}
			}

			if (type == 'increment') {
					if (curVal < params.max) {
						curVal++;
					}
			}
			if(curVal == 1){
				$(".maxCountMsg").removeClass("hide");
				$(".incrementer--increment").css({ 'opacity': '0.5','pointer-events': 'none' });
				//$(".incrementer--decrement").css({ 'opacity': '1','pointer-events': 'auto' });
			}else{
				$(".maxCountMsg").addClass("hide");
				$(".incrementer--increment").css({ 'opacity': '1','pointer-events': 'auto' });
				//$(".incrementer--decrement").css({ 'opacity': '0.5','pointer-events': 'none' });
			}

			if(curVal == 0){
				$(".incrementer--decrement").css('opacity', '0.5');
				$(".incrementer--decrement").attr('disabled','disabled');
			}else{
				$(".incrementer--decrement").css('opacity', '1');
				$(".incrementer--decrement").removeAttr('disabled');
			}
			//alert("assign-curVal>>"+curVal);
			if(cartId=="Y"){
				curVal=0;
				elDisplay.html(curVal);
				input.val(curVal);
			}else{
				elDisplay.html(curVal);
				input.val(curVal);
				cartId="N";
			}
			input.parent().trigger('incrementer.changed', [curVal]);
			return curVal;
		}
	}
	initSubmitForm(): any {
		let defer = $.Deferred();
		let _self = this;
		$('.btn-voucher--proceed').click(function() {
			let awardcode1:any;
			let awardcode2:any;
			let awardcode3:any;
			let awardcode4:any;
			if(_self.voucherList.length>0){
				for(let k=0;k<=_self.voucherList.length-1;k++){
					if(k==0){
						awardcode1 = _self.voucherList[k].AwardCode;
					}
					if(k==1)
					{
						awardcode2 =_self.voucherList[k].AwardCode;
					}
					if(k==2)
					{
						awardcode3 = _self.voucherList[k].AwardCode;
					}
					if(k==3)
					{
						awardcode4 = _self.voucherList[k].AwardCode;
					}
				}
			}
			let initialBalance = _self.partnerRdmForm.find('#partner-redeem--voucher-current-balance-gl').val();
			let totalRedeemedMiles= _self.partnerRdmForm.find('#partner-redeem--voucher-total').val();
			//let discountAmount1=_self.partnerRdmForm.find('#label--partner-redeem--voucher-type1').text().replace('RM','').trim();
			let discountAmount1=_self.partnerRdmForm.find('#label--partner-redeem--voucher-type1').text().trim();
			let discountAmount1Count=_self.partnerRdmForm.find('#partner-redeem--voucher-type1').text().trim();
			let discountAmount2=_self.partnerRdmForm.find('#label--partner-redeem--voucher-type2').text().trim();
			let discountAmount2Count=_self.partnerRdmForm.find('#partner-redeem--voucher-type2').text().trim();
			let discountAmount3=_self.partnerRdmForm.find('#label--partner-redeem--voucher-type3').text().trim();
			let discountAmount3Count=_self.partnerRdmForm.find('#partner-redeem--voucher-type3').text().trim();
			let discountAmount4=_self.partnerRdmForm.find('#label--partner-redeem--voucher-type4').text().trim();
			let discountAmount4Count=_self.partnerRdmForm.find('#partner-redeem--voucher-type4').text().trim();
			//alert("awardcode"+_self.partnerRdmForm.find('#awardcode_input1').val());
			//let awardcode1=_self.partnerRdmForm.find('#awardcode_input1').val();
			//alert("awardcode1>>"+awardcode1);
			let shoppingcartId  = $(".partner-redem-brands.active a").attr('id');
			let redeemCampaignId  = $(".partner-redem-brands.active input:hidden[class='campaignId']").val();

			if(parseInt(totalRedeemedMiles)<=0)
			{
				$(".successMsg").removeClass("showclass");
				$(".successMsg").addClass("hideclass");
				$(".errorMsg").removeClass("showclass");
				$(".errorMsg").addClass("hideclass");
				$(".onload_errorMsg").removeClass("showclass");
				$(".onload_errorMsg").addClass("hideclass");
				$(".partner-redeem-voucher").removeClass("hideclass");
				$(".partner-redeem-voucher").addClass("showclass");
				$(".overwhelming_resp").removeClass("showclass"); 
				$(".overwhelming_resp").addClass("hideclass");
				$(".maxcount_reached_onload").removeClass("showclass"); 
				$(".maxcount_reached_onload").addClass("hideclass");
				$(".maxcount_reached_onclick").removeClass("showclass"); 
				$(".maxcount_reached_onclick").addClass("hideclass");
				//$('.voucherEligibity').text("Sorry, you have insufficient MILES points for the redemption.");
				$(".voucherEligibity").removeClass("hideclass");
				$(".voucherEligibity").addClass("showclass");
				//$(".max4errorMsg").removeClass("showclass");
				//$(".max4errorMsg").addClass("hideclass");
			}else{
				let channel = $('[data-get-method]').attr('data-get-method');
				let cookieAccessToken = _self.getCookie("sapphire");
				var decodedToken = parseJwt(cookieAccessToken);
				var data = {
					'loyaltyToken':	decodedToken.extension_loyaltyToken,
					'enrichId': decodedToken.extension_flyerid,
					'campaignID':redeemCampaignId,
					'shoppingcartId':shoppingcartId,
					'initialBalance':initialBalance,
					'totalRedeemedMiles':totalRedeemedMiles,
					'discountAmount1':discountAmount1,
					'discountAmount1Count':discountAmount1Count,
					'discountAmount2':discountAmount2,
					'discountAmount2Count':discountAmount2Count,
					'discountAmount3':discountAmount3,
					'discountAmount3Count':discountAmount3Count,
					'discountAmount4':discountAmount4,
					'discountAmount4Count':discountAmount4Count,
					'awardcode1':awardcode1,
					'awardcode2':awardcode2,
					'awardcode3':awardcode3,
					'awardcode4':awardcode4,
					'channel':channel
				};
				_self.bookingformcommon.preloader();
				let submiturl = $('[data-get-lifestyle-redeem-url]').attr('data-get-lifestyle-redeem-url');
				
				$.ajax({
					type: 'POST',
					url: submiturl, //'/bin/services/new/partnerRedeemVoucher',
					data: data,
					success: function(data:any){
						//var json = JSON.parse(data);
						let json:any = null;
						if (typeof data === 'string') {
							json = JSON.parse(data);
						}	else {
							json = data;
						}
						_self.bookingformcommon.preloaderClose();
						if(json.code=="OK")
						{
							console.log("sucess");
							//let navMilesEl = _self.$memberHeader.find('.member-nav--miles-info .miles-value');
							let navMilesVal = json.currentBalance;
							$(".miles-value").text(numeral(navMilesVal).format('0,0'));
							document.cookie = "milesCount=" + navMilesVal + ";path=/";
							$(".successMsg").removeClass("hideclass");
							$(".successMsg").addClass("showclass");
							$("#gl-partnerName").text(json.description);
							$(".errorMsg").removeClass("showclass");
							$(".errorMsg").addClass("hideclass");
							$(".onload_errorMsg").removeClass("showclass");
							$(".onload_errorMsg").addClass("hideclass");
							$(".partner-redeem-voucher").removeClass("showclass");
							$(".partner-redeem-voucher").addClass("hideclass");
							$(".voucherEligibity").removeClass("showclass");
							$(".voucherEligibity").addClass("hideclass");
							$(".overwhelming_resp").removeClass("showclass"); 
							$(".overwhelming_resp").addClass("hideclass");
							$(".maxcount_reached_onload").removeClass("showclass"); 
							$(".maxcount_reached_onload").addClass("hideclass");
							$(".maxcount_reached_onclick").removeClass("showclass"); 
							$(".maxcount_reached_onclick").addClass("hideclass");
							//$(".max4errorMsg").removeClass("showclass");
							//$(".max4errorMsg").addClass("hideclass");
							$(".rmMaxErrorMsg1").removeClass("showclass");
							$(".rmMaxErrorMsg1").addClass("hideclass");
							$(".rmMaxErrorMsg2").removeClass("showclass");
							$(".rmMaxErrorMsg2").addClass("hideclass");
							$(".rmMaxErrorMsg3").removeClass("showclass");
							$(".rmMaxErrorMsg3").addClass("hideclass");
							$(".rmMaxErrorMsg4").removeClass("showclass");
							$(".rmMaxErrorMsg4").addClass("hideclass");

							$.magnificPopup.close();
							
						}else{
							
							$('.errMsg').text(json.message);
							$(".partner-redeem-voucher").removeClass("showclass");
							$(".partner-redeem-voucher").addClass("hideclass");
							$(".successMsg").removeClass("showclass");
							$(".successMsg").addClass("hideclass");
							$(".errorMsg").removeClass("hideclass");
							$(".errorMsg").addClass("showclass");
							$(".voucherEligibity").removeClass("showclass");
							$(".voucherEligibity").addClass("hideclass");
							$(".overwhelming_resp").removeClass("showclass"); 
							$(".overwhelming_resp").addClass("hideclass");
							$(".maxcount_reached_onload").removeClass("showclass"); 
							$(".maxcount_reached_onload").addClass("hideclass");
							$(".maxcount_reached_onclick").removeClass("showclass"); 
							$(".maxcount_reached_onclick").addClass("hideclass");
							//$(".max4errorMsg").removeClass("showclass");
							//$(".max4errorMsg").addClass("hideclass");
							$(".rmMaxErrorMsg1").removeClass("showclass");
							$(".rmMaxErrorMsg1").addClass("hideclass");
							$(".rmMaxErrorMsg2").removeClass("showclass");
							$(".rmMaxErrorMsg2").addClass("hideclass");
							$(".rmMaxErrorMsg3").removeClass("showclass");
							$(".rmMaxErrorMsg3").addClass("hideclass");
							$(".rmMaxErrorMsg4").removeClass("showclass");
							$(".rmMaxErrorMsg4").addClass("hideclass");

						}
								
					}, error: function(error: any) {
						defer.reject(error);
						_self.bookingformcommon.preloaderClose();
					}
				});
				return defer.promise();
			}
				function parseJwt (token:any): any {
					var base64Url = token.split('.')[1];
					var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
						return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
					}).join(''));
				
					return JSON.parse(base64);
				};
		});
	}
	initPopUp():any{
		$('.btn-member--submit').click(function() {
            $.magnificPopup.open({
                items: {
                    src: '#goldenvocher-popup'
                },
                type:'inline',
                midClick: false,
                closeBtnInside: true
                });
		});
		$('.btn-voucher--cancel').click(function() {
            $.magnificPopup.close();
		});
	}
}
let scope:Element = document.querySelector('#partner-redeem-voucher-form-lounge');

if (scope) {
	try {
	let membergrv = new memberPartnerRedeemGLVoucher();	
	membergrv.initPopUp();
	membergrv.initSubmitForm();
	membergrv.initTextInputs();
	membergrv.initSelectizeInputs();
	membergrv.initIncrementer();
	membergrv.initShopCart();
	
	} catch(e) {console.error(e);}
}